import React from "react";
import { Button } from "../../components/Button";
import { ArrowBackIos } from "@mui/icons-material";
import './404.css';

export const Page404: React.FC = () => {
    return (
        <div className="page404Container">
            <h1 className="page404Title">404</h1>
            <p className="page404Description">Página não encontrada...</p>
            <Button
            callback={() => window.history.back()}
            icon={<ArrowBackIos />}
            iconSlot="start"
            class="btn404Back"
            >
                Voltar
            </Button>
        </div>
    );
}